import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { CompanyEndpointMethod } from '../../../../quarantine/exchangeProtection/types';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';
import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';

export class DeviceFilterForGzRiskManagementDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getItems({ searchValue, page, limit, extra }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'RiskManagementDevices',
        method: 'getDevicesNames',
        payload: {
          page,
          limit,
          companyId: extra?.companyId,
          deviceName: searchValue,
          endpointIds: extra?.endpointIds,
        },
      });

      return {
        items: response.data,
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'RiskManagementDevices',
        method: 'getDevicesNames',
        payload: {
          limit: DEFAULT_DATA_LIMIT,
          companyId: request.extra?.companyId,
          endpointIds: request.extra?.endpointIds,
        },
      });

      return {
        items: response.data,
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
